export function propertyFiltersInit() {
	const propertyFiltersForm = document.getElementById( 'js-property-filters-form' );
	const propertyFilterSelects = document.querySelectorAll( '.property-filters__select-field' );

	if ( propertyFiltersForm && propertyFilterSelects ) {
		propertyFilterSelects.forEach((select) => {
			select.addEventListener('change', function () {
				propertyFiltersForm.submit();
			});
		});
	}
};

export function propertyLoadMoreInit() {

	const grid = document.querySelector( '.grid-layout__inner' );

	if ( ! grid ) {
		return;
	}

	document.addEventListener( 'mkdoSearchAjaxAppend', function ( event ) {
		if ( ! event.detail.items ) {
			return;
		}

		for ( let item of event.detail.items ) {
			grid.appendChild( item );
		}
	} );
}

export function propertyFilterUpdateSelects() {

	const propertySelect = document.querySelector( '.property-filters' );

	if ( ! window.location.search || ! propertySelect ) {
		return;
	}	
		
	const params = new URLSearchParams( window.location.search );	

	const searchFilterKeys = [  
		'property-let-type',
		'property-area',
		'property-price',
		'property-bedroom',
		'property-bathroom',
		'property-toilet',
		'property-sort',
		'property-university',
	];
	
	for ( const key of searchFilterKeys ) {
		const $element = document.getElementById( key + '-select' );

		if ( ! $element ) {
			continue;
		}
	
		const value = params.get( key );
		
		if ( ! value ) {
			$element.selectedIndex = 0;			
			continue;
		}
	
		$element.value = value;
	}
}

// 2024 Property Filter Popout

export function propertyFilterPopout() {
	
	const propertyFilterPopout      = document.querySelector( '.property-sidebar' );
	const propertyFilterPopoutOpen  = document.querySelector( '.property-index__filterbtn' );
	const propertyFilterPopoutClose = document.querySelector( '.property-sidebar__close-popout' );
	const body                      = document.querySelector( 'body' );
	const siteContainer             = document.querySelector( '.site-container' );
	const pkrdBtnLoading            = document.querySelectorAll( '.pkrd-btn--loading-trigger' );

	if ( ! propertyFilterPopout || ! propertyFilterPopoutOpen || ! propertyFilterPopoutClose ) {
		return;
	}

	window.addEventListener( 'click', function (e) { 
		if ( ! propertyFilterPopout.contains( e.target ) && ! propertyFilterPopoutOpen.contains( e.target ) && propertyFilterPopout.classList.contains( 'property-sidebar--active' ) ) {
			propertyFilterPopout.classList.remove('property-sidebar--active');
			body.classList.remove('property-popout-active');
		}
	});

	propertyFilterPopoutOpen.addEventListener( 'click', function (e) {
		propertyFilterPopout.classList.add('property-sidebar--active');
		body.classList.add('property-popout-active');
	});

	propertyFilterPopoutClose.addEventListener( 'click', function (e) {
		propertyFilterPopout.classList.remove('property-sidebar--active');
		body.classList.remove('property-popout-active');
	});

	if ( pkrdBtnLoading && siteContainer ) {
		pkrdBtnLoading.forEach( ( btn ) => {
			btn.addEventListener( 'click', function (e) {
				siteContainer.classList.add('site-container--loading');
			});
		});
	}
}